import Pacman from "src/app/components/layout/Pacman";
import { OrderStatusGrid } from "src/app/components";
import { useOrderOnGoingList } from "src/app/hooks";
import { useAuth } from "src/app/utils/useAuth";

const OrderStatusGridContainer = () => {
    const { orderList, loading } = useOrderOnGoingList();
    const { currentUser } = useAuth();
    if (loading)
        return (
            <div className="h-100 w-100 d-flex center">
                <Pacman />
            </div>
        );
    return <OrderStatusGrid role={currentUser.role} rowData={orderList} />;
};

export default OrderStatusGridContainer;
